import { useQuery } from '@tanstack/react-query';
import { listComments, type CommentDTO } from '../services/api/comments';

/**
 * Phase 25 Plan 25-05 — comment list hook.
 *
 * Cache key locked to ['comments', taskId] (Plan 25-04's create / 25-05's
 * edit + delete invalidate the same key).
 *
 * staleTime=0 so the modal refetches on each open per D-10 ("load all-at-once
 * on modal open"); no `refetchInterval` since v6.0 explicitly defers real-time
 * streaming.
 */
export function useComments(taskId: number | null) {
  return useQuery<CommentDTO[]>({
    queryKey: ['comments', taskId],
    queryFn: () => listComments(taskId as number),
    enabled: taskId !== null && Number.isFinite(taskId),
    staleTime: 0,
  });
}
